export default "__VITE_ASSET__P6lBvJDG__"